export default class Http {
  constructor(path, setEntities, setNotice) {
    this.path = path;
    this.setEntities = setEntities;
    this.setNotice = setNotice;
  }

  static applicationJsonHeader = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content"),
  };

  static errorNotice = {
    kind: "error",
    open: true,
    message: "An Error occurred - please try again or contact support.",
  };

  submitPermission = (
    id_340b,
    tpa_access_key,
    eligibility_role,
    submission_role,
    submitting,
    setSubmitting,
    from_tpa_modal
  ) => {
    if (submitting) {
      return;
    }

    setSubmitting(true);

    fetch(this.path, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
      body: JSON.stringify({
        from_tpa_modal,
        access_key: tpa_access_key,
        entity_tpa_permission: {
          id_340b: id_340b,
          eligibility_role,
          submission_role,
        },
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((data) => {
        this.setEntities(data.permissions);
        this.setNotice({
          kind: "success",
          open: true,
          message: data.notice,
        });
      })
      .catch((response) => {
        response.json().then((res) => {
          this.setNotice({
            kind: "error",
            open: true,
            message: res.error,
          });
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  deletePermission = (permission_id, id_340b) => {
    fetch(`${this.path}/${permission_id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
      body: JSON.stringify({
        id_340b: id_340b,
      }),
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 299) {
          res.json().then((data) => {
            this.setEntities(data.permissions);
            this.setNotice({
              kind: "success",
              open: true,
              message: data.notice,
            });
          });
        } else {
          throw res;
        }
      })
      .catch((response) => {
        response.json().then((res) => {
          this.setNotice({
            kind: "error",
            open: true,
            message: res.error,
          });
        });
      });
  };
}
